import React from "react";
export const GRADE_CONST = {
    "ALL": "Toàn trường",
    "GRADE_MN_2": "Mầm non 2 tuổi",
    "GRADE_MN_3": "Mầm non 3 tuổi",
    "GRADE_MN_4": "Mầm non 4 tuổi",
    "GRADE_MN_5": "Mầm non 5 tuổi",
    "GRADE_1": "Khối 1",
    "GRADE_2": "Khối 2",
    "GRADE_3": "Khối 3",
    "GRADE_4": "Khối 4",
    "GRADE_5": "Khối 5",
    "GRADE_6": "Khối 6",
    "GRADE_7": "Khối 7",
    "GRADE_8": "Khối 8",
    "GRADE_9": "Khối 9",
    "GRADE_10": "Khối 10",
    "GRADE_11": "Khối 11",
    "GRADE_12": "Khối 12"
}
export const GRADE_ALL = [
    {
        "id": "ALL",
        "name": "Toàn trường"
    },
    {
        "id": "GRADE_MN_2",
        "name": "Mầm non 2 tuổi"
    },
    {
        "id": "GRADE_MN_3",
        "name": "Mầm non 3 tuổi"
    },
    {
        "id": "GRADE_MN_4",
        "name": "Mầm non 4 tuổi"
    },
    {
        "id": "GRADE_MN_5",
        "name": "Mầm non 5 tuổi"
    },
    {
        "id": "GRADE_1",
        "name": "Khối 1"
    },
    {
        "id": "GRADE_2",
        "name": "Khối 2"
    },
    {
        "id": "GRADE_3",
        "name": "Khối 3"
    },
    {
        "id": "GRADE_4",
        "name": "Khối 4"
    },
    {
        "id": "GRADE_5",
        "name": "Khối 5"
    },
    {
        "id": "GRADE_6",
        "name": "Khối 6"
    },
    {
        "id": "GRADE_7",
        "name": "Khối 7"
    },
    {
        "id": "GRADE_8",
        "name": "Khối 8"
    },
    {
        "id": "GRADE_9",
        "name": "Khối 9"
    },
    {
        "id": "GRADE_10",
        "name": "Khối 10"
    },
    {
        "id": "GRADE_11",
        "name": "Khối 11"
    },
    {
        "id": "GRADE_12",
        "name": "Khối 12"
    }
]
class GradeManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLock: false,
            onChange: false,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (this.state.gradeId !== nextProps.gradeId) {
            this.setState({
                gradeId: nextProps.gradeId,
                isLock: !(nextProps.isLock == undefined),
            })
        }
    }
    onChangeGrade = (e) => {
        this.setState({
            gradeId: e.target.value
        }, () =>{
            this.props.onUpdateGrade(this.state.gradeId)
        })
    };
    renderGrade = () => {
        return GRADE_ALL.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    render() {
        let {gradeId}  = this.state
        return (
            <select
                className="form-control kt-input pd-4-input hei-input"
                value={gradeId}
                disabled={this.state.isLock}
                onChange={this.onChangeGrade}
            >
                <option value="">Chọn khối</option>
                {this.renderGrade()}
            </select>
        );
    }
}
export default GradeManager;
